import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/index.css";
import { applySEO } from "@/lib/seo";
import { initGA, trackPageView } from "@/lib/analytics";

import { Layout } from "@/components/site/Layout";
import Home from "@/pages/Home";
import HowItWorks from "@/pages/HowItWorks";
import Packages from "@/pages/Packages";
import Gallery from "@/pages/Gallery";
import FAQ from "@/pages/FAQ";
import About from "@/pages/About";
import Book from "@/pages/Book";
import ComingSoon from "@/pages/ComingSoon";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    initGA();
  }, []);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    const meta = applySEO(pathname);
    trackPageView(pathname, meta.title);
  }, [pathname]);
  return null;
}

function useLenis() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
}

function App() {
  useLenis();
  return (
    <div className="App grain">
      <BrowserRouter>
        <ScrollManager />
        <Toaster position="top-center" richColors />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/packages" element={<Packages />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/about" element={<About />} />
            <Route path="/book" element={<Book />} />
            <Route path="/metro-vancouver" element={<ComingSoon />} />
          </Route>
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
